import styled from 'styled-components';
import {Space} from '@baidu/qianfan-antd-kit';
import {getCDNIcon} from '@/utils/util';
import {COLOR_PRIMARY, COLOR_TEXT_DESCRIPTION, COLOR_TEXT_TERTIARY} from '../common';
import {SCSpace} from '../components/Space';

interface StyleProps {
    $iframe?: boolean;
}

export const SCIndexContainer = styled.div`
    margin: ${(props: any) => {
        return props.$iframe
            ? 0 : '1.6rem';
    }};
    background: ${(props: any) => props.$bg || 'white'};
    padding: ${(props: any) => (props.$iframe ? 0 : '2.4rem')};
    border-radius: 6px;
    @media (max-width: 600px) {
        padding: ${(props: any) => {
        if (props.$newVersion) {
            return props.$padding || '1.2rem';
        }
        return '2.4rem';
    }};
    }
`;

export const SCIndexWrapper = styled.div`
    margin: 1.6rem;
    padding: ${(props: any) => {
        return props.$isActivated
            ? '2.4rem 12.4rem' : '2.4rem';
    }};
    border-radius: 6px;
    background: ${(props: any) => {
        return props.$isActivated
            ? 'url(https://bcecdn.bj.bcebos.com/eop-fe/risk/qualify/1280-bg%402x.png)' : '#fff';
    }};
    background-size: ${(props: any) => {
        return props.$isActivated
            ? 'cover' : 'none';
    }};
    height: ${(props: any) => {
        return props.$isActivated
            ? 'calc(100vh - 84px)' : 'auto';
    }};
    @media (max-width: 600px) {
        background: ${(props: any) => {
        return props.$newVersion
            ? `url(${getCDNIcon('mobileIndexBg.svg')})`
            : (props.$isActivated
                ? 'url(https://bcecdn.bj.bcebos.com/eop-fe/risk/qualify/1280-bg%402x.png)'
                : 'white');
    }};
        background-size: ${(props: any) => {
        return props.$newVersion
            ? 'contain' : (
                props.$isActivated
                    ? 'cover' : 'none'
            );
    }};
        background-repeat: no-repeat;
        padding: ${(props: any) => (props.$newVersion ? '1.6rem' : '2.4rem')};
        margin: ${(props: any) => (props.$newVersion ? '0' : '1.6rem')};
        height: auto;
    }
    h1 {
        margin-bottom: 1.6rem;
    }
`;

export const SCChoice = styled.div`
    padding: 2.4rem 3.6rem;
    @media (max-width: 600px) {
        padding: 2.4rem 2rem;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: stretch;
    }
`;

export const SCChoiceInfo = styled.div`
    display: flex;
    h2 {
        text-align: center;
    }
    @media (max-width: 600px) {
        justify-content: center;
        flex-direction: column;
        align-items: stretch;
    }
`;

export const SCChoiceTitleH5 = styled.div`
    display: flex;
    width: 100%;
    border-bottom: 1px solid #E8E9EB;
    justify-content: space-between;
    padding-bottom: 1.2rem;
`;

export const SCChoiceTitleLeftH5 = styled.div`
    display: flex;
    align-items: center;
    font-size: 1.6rem;
    line-height: 2.4rem;
    h2 {
        margin: 0 1.2rem;
        font-family: PingFangSC-Regular;
        font-size: 1.6rem;
        color: #151B26;
        line-height: 2.4rem;
        font-weight: 400;
    }
`;

export const SCChoiceIcon = styled.div`
    margin-right: 2.4rem;
    @media (max-width: 600px) {
        margin-right: 0;
        margin-bottom: 2.4rem;
        font-size: 3.2rem;
    }
`;

export const SCChoiceCard = styled(SCChoice)`
    min-height: 15rem;
    margin-bottom: 1.6rem;
    border: 1px solid rgba(232, 233, 235, 1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-radius: 6px;
    background-color: ${(props: any) => {
        return props.$isActivated
            ? '#fff' : 'none';
    }};
    background-size: cover;
    box-shadow: ${(props: any) => {
        return props.$isActivated
            ? '0px 2px 8px 0px rgba(232,239,252,1)' : 'none';
    }};
    @media (max-width: 600px) {
        background-color: #fff;
        box-shadow: 0px 2px 8px 0px rgba(232,239,252,1);
        padding: ${(props: any) => (props.$newVersion ? '1.6rem 1.2rem' : '2.4rem 2rem')};
        border: none;
    }
    cursor: pointer;
    &:hover {
        border-color: ${COLOR_PRIMARY};
    }
`;

function bgImage(image: any) {
    return (props: any) => {
        return props.$isActivated
            ? 'none' : image;
    };
}

export const SCPersonChoice = styled(SCChoiceCard)`
    @media (min-width: 821px) {
        background-image: ${bgImage(`url(${getCDNIcon('personIndexBg%401x.png')})`)};
        @media (-webkit-min-device-pixel-ratio: 2),(min-device-pixel-ratio: 2) {
            background-image: ${bgImage(`url(${getCDNIcon('personIndexBg%402x.png')})`)};
        }
        @media (-webkit-min-device-pixel-ratio: 3),(min-device-pixel-ratio: 3) {
            background-image: ${bgImage(`url(${getCDNIcon('personIndexBg%403x.png')})`)};
        }
    }
`;

export const SCCompanyChoice = styled(SCChoiceCard)`
    @media (min-width: 821px) {
        background-image: ${bgImage(`url(${getCDNIcon('companyIndexBg%401x.png')})`)};
        @media (-webkit-min-device-pixel-ratio: 2),(min-device-pixel-ratio: 2) {
            background-image: ${bgImage(`url(${getCDNIcon('companyIndexBg%402x.png')})`)};
        }
        @media (-webkit-min-device-pixel-ratio: 3),(min-device-pixel-ratio: 3) {
            background-image: ${bgImage(`url(${getCDNIcon('companyIndexBg%403x.png')})`)};
        }
    }
`;

export const SCGap = styled.div`
    width: 1.6rem;
`;

export const SCCardFooter = styled.div`
    border-top: 1px solid #f4f4f4;
    text-align: center;
    padding-top: 1rem;
    font-size: 1.5rem;
`;

export const SCCardTitle = styled.h1`
    margin-top: 0;
    vertical-align: middle;
    font-size: ${(props: any) => (props.$iframe ? '1.4rem' : '1.8rem')}; ;
    @media (max-width: 600px) {
        text-align: center;
    }
`;

export const SCCardTitleH5 = styled.div`
    font-family: PingFangSC-Regular;
    font-size: 1.6rem;
    color: #151B26;
    line-height: 2.4rem;
    font-weight: 400;
`;

export const SCDescription = styled.div`
    display: flex;
    color: ${COLOR_TEXT_DESCRIPTION};
    font-family: PingFangSC-Regular;
    font-size: 1.2rem;
    color: #5C5F66;
    line-height: 2rem;
    font-weight: 400;
    margin-bottom: 0.8rem;
    @media (max-width: 600px) {
        font-size: ${(props: any) => (props.$newVersion ? '1.4rem' : '1.2rem')};
        color: ${(props: any) => (props.$newVersion ? '#151B26' : '#5C5F66')};
        line-height: ${(props: any) => (props.$newVersion ? '2.4rem' : '2rem')};
        margin-bottom: ${(props: any) => (props.$newVersion ? '1.6rem' : '.8rem')};
    }
`;

export const SCTag = styled.span`
    font-family: PingFangSC-Regular;
    border: .1rem solid rgba(181,209,255,1);
    border-radius: .2rem;
    font-size: 1.2rem;
    color: #2468F2;
    line-height: 2rem;
    font-weight: 400;
    padding: 0 .4rem;
    margin-right: 1.2rem;
    min-width: 6.4rem;
    text-align: center;
    height: fit-content;
    @media (max-width: 600px) {
        font-size: ${(props: any) => (props.$newVersion ? '1.4rem' : '1.2rem')};
        color: ${(props: any) => (props.$newVersion ? '#84868C' : '#2468F2')};
        line-height: ${(props: any) => (props.$newVersion ? '2.4rem' : '2rem')};
        border: ${(props: any) => (props.$newVersion ? 'none' : '.1rem solid rgba(181,209,255,1)')};;
    }
`;

export const SCCardTip = styled.div`
    color: ${COLOR_TEXT_TERTIARY};
    font-family: PingFangSC-Regular;
    font-size: 1.2rem;
    line-height: 2rem;
    font-weight: 400;
    text-align: ${(props: any) => (props.$center ? 'center' : 'left')};
    p {
        margin-bottom: 4px;
    }
    
    @media (max-width: 600px) {
        font-size: 1.3rem;
    }
`;

export const SCActivated = styled.div`
    padding-top: 6.4rem;
    font-size: 1.4rem;
    margin-bottom: 1.6rem;
    .ant-alert-info {
        background-color: #e6f0ff;
    }
    .ant-alert-info .ant-alert-icon {
        color: ${COLOR_PRIMARY}
    }
    .ant-alert-message {
        font-family: PingFangSC-Regular;
        font-size: 1.2rem,;
        color: #151B26;
        line-height: 2rem;
        font-weight: 400;
    }
    @media (max-width: 600px) {
        padding-top: 0;
    }
`;

export const SCActivatedTip = styled.div`
    line-height: 1.5;
    font-family: PingFangSC-Regular;
    color: rgba(8,14,26,.95);
    line-height: 2.2rem;
    font-weight: 400;
    margin-bottom: 1.6rem;
`;

export const SCCompanyIndexIcon = styled.div`
    width: 60px;
    height: 60px;
    margin: 0 auto 10px;
    background-image: url(${getCDNIcon('companyIndex%401x.png')});
    background-size: 100%;
    @media (-webkit-min-device-pixel-ratio: 2),(min-device-pixel-ratio: 2) {
        background-image: url(${getCDNIcon('companyIndex%402x.png')});
    }
    @media (-webkit-min-device-pixel-ratio: 3),(min-device-pixel-ratio: 3) {
        background-image: url(${getCDNIcon('companyIndex%403x.png')});
    }
    background-repeat: no-repeat;
`;

export const SCCompanyIndexIconH5 = styled(SCCompanyIndexIcon)`
    width: 32px;
    height: 32px;
    margin: 0;
`;

export const SCPersonIndexIcon = styled.div`
    width: 60px;
    height: 60px;
    margin: 0 auto 10px;
    background-image: url(${getCDNIcon('personIndex%401x.png')});
    background-size: 100%;
    @media (-webkit-min-device-pixel-ratio: 3),(min-device-pixel-ratio: 3) {
        background-image: url(${getCDNIcon('personIndex%402x.png')});
    }
    @media (-webkit-min-device-pixel-ratio: 2),(min-device-pixel-ratio: 2) {
        background-image: url(${getCDNIcon('personIndex%403x.png')});
    }
    background-repeat: no-repeat;
`;

export const SCPersonIndexIconH5 = styled(SCPersonIndexIcon)`
    width: 32px;
    height: 32px;
    margin: 0;
`;

export const SCPrimaryTip = styled.div`
    font-family: PingFangSC-Regular;
    font-size: 1.2rem;
    color: #2468F2;
    letter-spacing: 0;
    line-height: 2rem;
    font-weight: 400;
`;

export const SCHelpCard = styled.div`
    border: .1rem solid rgba(232,233,235,1);
    border-radius: .6rem;
    padding: 2.4rem;
    h2 {
        margin-bottom: 1.6rem;
    }
    @media (max-width: 600px) {
        background-color: #fff;
    }
`;

export const SCHelpContent = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;;
    @media (max-width: 600px) {
        flex-direction: column;
    }
`;

export const SCSubmitButton = styled(SCSpace)`
    @media (max-width: 600px) {
        margin-top: 2.4rem;
    }
`;

export const SCCardDescription = styled.div`
    @media (max-width: 600px) {
        margin-top: ${(props: any) => (props.$newVersion ? '1.6rem' : '-1.2rem')};
    }
`;

export const SCInfoAlert = styled(Space)`
    background: #E6F0FF;
    border-radius: 4px;
    padding: 1.2rem;
    font-family: PingFangSC-Regular;
    font-size: 1.2rem;
    color: #151B26;
    line-height: 2rem;
    font-weight: 400;
`;

export const SCOutlineTag = styled.span`
    border: ${(props: any) => `1px solid ${props.$color}`};
    color: ${(props: any) => props.$color};
    border-radius: 2px;
    padding: 0 .8rem;
    font-family: PingFangSC-Regular;
    font-size: 1.2rem;
    color: #F33E3E;
    line-height: 2rem;
    font-weight: 400;
`;

export const SCDisabledOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.6);
    z-index: 10;
    cursor: not-allowed;
    border-radius: 6px;
`;

export const SCActiveTip = styled.span`
    font-family: PingFangSC-Regular;
    font-size: 1.4rem;
    color: #5C5F66;
    line-height: 2rem;
    font-weight: 400;
`;

export const SCActiveTitle = styled.div`
    font-family: PingFangSC-Medium;
    font-size: 2rem;
    color: #151B26;
    line-height: 2.4rem;
    font-weight: 500;
    margin-bottom: .8rem;
`;

export const SCFormContainer = styled.div`
    .ant-form-item {
        margin-bottom: ${(props: StyleProps) => (props.$iframe ? '1.6rem' : '2.4rem')};
        .ant-row {
            justify-content: ${(props: StyleProps) => (props.$iframe ? 'center' : 'flex-start')};
        }
    }
`;
